import React from 'react';
import { Hero } from './components/Hero';
import { EmotionalHook } from './components/EmotionalHook';
import { ScienceTruth } from './components/ScienceTruth';
import { Agitation } from './components/Agitation';
import { ProductPresentation } from './components/ProductPresentation';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full flex flex-col font-sans text-charcoal bg-cream overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <EmotionalHook data-id="element-2" />
      <ScienceTruth data-id="element-3" />
      <Agitation data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Pricing data-id="element-7" />
      <Guarantee data-id="element-8" />
      <Urgency data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}